<template>
    <div class="order_box_item" @click="gotoDetail(info.goods_type,info.id,info.order_num)">
        <div class="l1">
            <span class="game_name">{{ info.app_name }}</span>
            <span class="status" :class="[{'status0': info.status == 3},{'status1': info.status == 4 || info.status == 5 || info.status == 6},{'status2': info.status == 1}]">{{ status_maps[info.status] }}</span>
        </div>
        <div class="l2">
            <van-image class="icon first_pic" :src="info.first_pic" v-if="info.first_pic" />
            <van-image class="icon" :src="info.icon" v-else/>
            <div class="info">
                <p class="type">交易类型：{{info.goods_type_name}}</p>
                <p class="goods_name">
                    <span class="name" v-if="info.goods_type == 1">{{ info.goods_name }}</span>
                    <span class="name" v-else>角色名：{{ info.role_name }}</span>
                    <span class="num" v-if="info.goods_type == 1">X{{ info.num }}</span>
                </p>
                <p class="server_name">
                    {{ info.server_name }}&nbsp;
                    <span v-if="info.goods_type == 1">{{ info.role_name }}</span>
                </p>
            </div>
        </div>
        <div class="price">售价：<span class="yen">&yen;</span>&nbsp;<i>{{ (Number(info.price) * Number(info.num)).toFixed(3) }}</i></div> 
    </div>
</template> 

<script>
    export default {
        props: ['info','otype','status_maps'],
        data() {
            return {}
        },
        computed: {},
        created() {},
        mounted() {},
        methods: {
            gotoDetail(type,id,order_num) {
                if(type == 1) {
                    this.$store.commit('setGameInfo', {
                      name:this.info.app_name,
                      icon:this.info.icon,
                      id:this.info.app_id
                    })
                    this.$router.push({
                      name: "onsell",
                      query: {
                        id
                      },
                    });
                }else {
                    this.$router.push({
                        name: 'order.detail',
                        query: {
                            id
                        }
                    })
                } 
            },
        },
        watch: {},
    }
</script>

<style lang="less" scoped>
.order_box_item {
    background-color: #fff;
    border-radius: 1rem;
    padding: 1rem;
    margin-bottom: 1.6rem;
    cursor: pointer;
    .l1 {
        display: flex;
        justify-content: space-between;
        margin-bottom: 1rem;
        .game_name {
            font-size: 1.4rem;
            color: #000;
            font-weight: 700;
        }
        .status {
            font-size: 1.4rem;
            &.status0 {
                color: #ff0000;
            }
            &.status1 {
                color: #EF4D3D;
            }
            &.status2 {
                color: #9999;
            }
        }
    }
    .l2 {
        display: flex;
        align-items: flex-start;
        margin-bottom: 1rem;
        .icon {
            width: 9rem;
            height: 9rem;
            border-radius: 1.6rem;
            overflow: hidden;
            margin-right: 1rem;
        }
        .info {
            flex: 1;
            overflow: hidden;
            .type {
                font-size: 1.4rem;
                color: #000;
                font-weight: 700;
                margin-bottom: .8rem;
            }
            .goods_name {
                display: flex;
                align-items: flex-start;
                justify-content: space-between;
                margin-bottom: .8rem;
                font-size: 1.4rem;
                .name {
                    flex: 1;
                    word-break: break-all;
                }
                .num {
                    margin-left: .8rem;
                }
            }
            .server_name {
                color: #999;
                font-size: 1.2rem;
            }
        }
    }
    .price {
        text-align: end;
        font-size: 1.6rem;
        color: #000;
        .yen {
            font-size: 1.2rem;
        }
        i {
            font-size: 1.8rem;
            font-weight: 700;
        }
    }
}
</style>
